import styled from 'styled-components';
import FlexContainer from '@/components/molecules/FlexContainer';
import { AnimatedAppearance, size } from '@/styles/template';
import { BoldTextXS } from '@/pages/designSystem/Fonts';
import Item from '@/components/atoms/UI/Item/Item';

export const AddDomainWrap = styled(FlexContainer)`
  @media (max-width: ${size.tablet}) {
    flex-wrap: wrap;
    & > * {
      width: 100%;
    }
  }
`;

export const ExampleDomain = styled(BoldTextXS)`
	color: ${props => props.theme.color.MidtoneItem};
`;


export const AnimatedItem = styled(Item)`
    ${AnimatedAppearance};
`;

